import { connectMainSocket, getMainSocket } from '../../clients/mainSocketClient'
import { MAIN_SOCKET_API_EVENTS } from '../../constants/api/mainSocket'

const registerFormFilledListeners = (socket, callback) => {
  socket.off(MAIN_SOCKET_API_EVENTS.FORM_FILLED_CREATED)
  socket.off(MAIN_SOCKET_API_EVENTS.FORM_FILLED_UPDATED)
  socket.on(MAIN_SOCKET_API_EVENTS.FORM_FILLED_CREATED, payload => callback(payload, 'created'))
  socket.on(MAIN_SOCKET_API_EVENTS.FORM_FILLED_UPDATED, payload => callback(payload, 'updated'))
}

const onFormFilledEvents = callback => {
  connectMainSocket().then(() => {
    const socket = getMainSocket()
    if (!socket) return
    registerFormFilledListeners(socket, callback)
  })
}

const FormSocket = {
  onFormFilledEvents
}

export default FormSocket
